import { Chip, useTheme } from "@mui/material";
import { getMinMaxPlayers } from "./utils.js";
import { useMediaQuery } from "../utilities/index.js";
import { useTranslation } from "next-i18next";
import React from "react";
export const NumberOfPlayersChip = ({ product }) => {
    const { t } = useTranslation("c-common");
    const theme = useTheme();
    const isAtLeastLg = useMediaQuery(theme.breakpoints.up("lg"));
    const { minPlayers, maxPlayers } = getMinMaxPlayers(product);
    return (React.createElement(Chip, { label: t("forMinMaxPlayers", "{{minPlayers}} – {{maxPlayers}} Personen", {
            minPlayers,
            maxPlayers,
        }), size: isAtLeastLg ? "medium" : "small" }));
};
//# sourceMappingURL=number-of-players-chip.js.map